var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlants2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 188,
    viewBox: "0 0 82 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2991 159.739C33.2991 159.739 -4.77763 101.67 0.893916 88.3422C6.56546 75.0141 26.6737 97.8678 26.6737 97.8678C26.6737 97.8678 -2.84417 19.8068 17.148 2.66324C37.1402 -14.4803 43.8043 73.1193 43.8043 73.1193C43.8043 73.1193 61.8501 22.6554 76.1708 41.6938C90.4914 60.7321 54.258 100.717 54.258 100.717C54.258 100.717 79.0065 101.67 72.3038 117.86C65.6011 134.05 47.5553 151.18 47.5553 151.18L33.2991 159.739Z",
    fill: "#36CA5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8068 146.411C22.8068 146.411 -0.033984 114.044 11.3864 107.38C22.8069 100.716 28.5171 120.709 28.5171 120.709C28.5171 120.709 29.4709 33.1347 47.5683 39.7988C65.6657 46.4629 58.9887 99.7625 58.9887 99.7625C58.9887 99.7625 81.8296 84.5396 80.9015 106.427C79.9734 128.314 49.476 147.391 49.476 147.391",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7656 148.319L23.7734 126.419",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7195 158.785L43.7656 104.532",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6733 140.701L63.7578 116.906",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8501 142.609H11.3992L16.4391 187.349H56.8102L61.8501 142.609Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlants2);
export default __webpack_public_path__ + "static/media/plants 2.af0e0e71af9d33d8e9f242b0bbfa6c52.svg";
export { ForwardRef as ReactComponent };